import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { store } from "./app/store";
// import { persistor, store } from "./app/store";
import "./index.css";
import { App } from "./app/App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { getCookieStateAnalytics } from "./features/app/UserRelatedSlice";
import { isPrerender } from "./util/isPrerender";
// import { PersistGate } from 'redux-persist/integration/react';

ReactGA.initialize("G-T75PDN538Y");

// 1) Stub fetch to your API during prerender so components don't crash
if (typeof window !== "undefined" && isPrerender) {
  const origFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === "string" ? input : (input as Request).url;
    // noop/stub your own API endpoints that fail in prerender
    if (url.includes("api.siqisu.co.uk/api/nvre/v1/")) {
      // return minimal OK response; tailor by endpoint if needed
      if (url.includes("/check-permission")) {
        return Promise.resolve(
          new Response(JSON.stringify({ ok: true }), {
            status: 200,
            headers: { "Content-Type": "application/json" },
          })
        );
      }
      if (url.includes("/developments")) {
        return Promise.resolve(
          new Response(JSON.stringify([]), {
            status: 200,
            headers: { "Content-Type": "application/json" },
          })
        );
      }
      return Promise.resolve(
        new Response("{}", {
          status: 200,
          headers: { "Content-Type": "application/json" },
        })
      );
    }
    // let other same-origin requests pass
    return origFetch(input as any, init);
  };

  // 2) Disable Mapbox (WebGL fails in headless)
  (window as any).__DISABLE_MAPBOX__ = true;
}

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

const RootComponent = () => {
  const analytics = useSelector(getCookieStateAnalytics);
  useEffect(() => {
    if (analytics) {
      reportWebVitals(SendAnalytics);
    }
  }, [analytics]);

  return <App />;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <RootComponent />
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>
);
